module.exports = __webpack_public_path__ + "img/BRL.6c3aa562.svg";